import { DateUtility } from '@mchs/web-core';
import { Demographics } from './demographics';

export enum SchedulingTarget {
  Myself = 'Myself',
  SomeoneElse = 'SomeoneElse',
}

export enum PreviouslySeen {
  Yes = 'Yes',
  No = 'No',
  NotSure = "I'm not sure",
}

export enum HaveMRN {
  Yes = 'Yes',
  No = 'No',
}

export interface PatientDetails {
  target?: SchedulingTarget;
  demographics?: Demographics;
  previouslySeen?: PreviouslySeen;
  haveMRN?: HaveMRN;
}

///////////////////////////////////////////////
// defaults for testing
export const DefaultTestPatientDemographics: Demographics = {
  firstName: 'First',
  lastName: 'Last',
  middleName: 'Middle',
  nameSuffix: 'Jr',
  dateOfBirth: DateUtility.formatDateTwoDigitDayMonth(new Date(2005, 10, 8, 0, 0, 0, 0)),
  preferredSex: 'Female',
};

export const DefaultTestPatientDetails: PatientDetails = {
  target: SchedulingTarget.Myself,
  demographics: DefaultTestPatientDemographics,
  previouslySeen: PreviouslySeen.No,
  haveMRN: undefined,
};
